/*
 * @Author: LiuChuanQi
 * @Date: 2023-04-04 17:01:05
 * @LastEditTime: 2023-04-06 18:24:56
 * @LastEditors: LiuChuanQi
 * @Description:
 * @FilePath: \speedtest-m-v2\utils\hook.js
 *
 */
/**
 * 对数据进行解密
 * @param {String} data
 * @return {JSON}
 * */
import CryptoJS from 'crypto-js'
import Clipboard from "clipboard";
const ASEKEY = '5ECC5D62140EC099'
const ASEIV = 'E63EA892A702EEAA'
export const aesDecrypt = (data) => {
  //秘钥（后端提供）由于对称解密使用的算法是 AES-128-CBC算法，数据采用 PKCS#7 填充 ， 因此这里的 key 需要为16位！
  let key = ASEKEY
  // 偏移量（后端提供）
  let iv = ASEIV
  const keyUTF8 = CryptoJS.enc.Utf8.parse(key)
  const offsetUTF8 = CryptoJS.enc.Utf8.parse(iv)
  const bytes = CryptoJS.AES.decrypt(data, keyUTF8, {
    iv: offsetUTF8,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return JSON.parse(CryptoJS.enc.Utf8.stringify(bytes).toString())
}

/**
 * 对参数进行加密
 * @param {*} data
 * @returns
 */
export const aesEncrypt = (data) => {
  //秘钥（后端提供）由于对称解密使用的算法是 AES-128-CBC算法，数据采用 PKCS#7 填充 ， 因此这里的 key 需要为16位！
  let key = ASEKEY
  // 偏移量（后端提供）
  let iv = ASEIV
  const keyUTF8 = CryptoJS.enc.Utf8.parse(key)
  const offsetUTF8 = CryptoJS.enc.Utf8.parse(iv)
  const dataUTF8 = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
  const bytes = CryptoJS.AES.encrypt(dataUTF8, keyUTF8, {
    iv: offsetUTF8,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  //console.log(CryptoJS.enc.Base64.stringify(bytes.ciphertext));
  return CryptoJS.enc.Base64.stringify(bytes.ciphertext)
}

// 获取num 天前的日期
export const getDaysAgo = function (num) {
  let myDate = new Date()
  let lw = new Date(myDate - 1000 * 60 * 60 * 24 * num) //最后一个数字30可改，30天的意思
  let lastY = lw.getFullYear()
  let lastM = lw.getMonth() + 1
  let lastD = lw.getDate()
  let startData =
    lastY +
    "-" +
    (lastM < 10 ? "0" + lastM : lastM) +
    "-" +
    (lastD < 10 ? "0" + lastD : lastD) //三十天之前日期
  lastM = lastM < 10 ? "0" + lastM : lastM
  lastD = lastD < 10 ? "0" + lastD : lastD
  return { startData, lastY, lastM, lastD }
}

/**
 * 获取url参数
 * @param {string} variable
 * */
export const getQueryVariable = (variable) => {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] === variable) {
          return pair[1];
      }
  }
  return false;
}

export function  copyFun(id) {
    let clipboard = new Clipboard(id); // 获取点击按钮的元素
    /* 注意此事件监听是异步的   */
    clipboard.on('success', (e) => {
        console.info('Text:', e.text);
        e.clearSelection();
        // 释放内存
        clipboard.destroy();
        this.$message.success("复制成功");
    });
    // 复制失败
    clipboard.on('error', (e) => {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
        // 释放内存
        clipboard.destroy();
        this.$message.error("复制失败");
    });
}


//手机号脱敏
export const desensitization = (phone) => {
    if (phone) {
        let reg = /(\d{3})\d*(\d{4})/
        return phone.replace(reg, '$1****$2');
    } else {
        return '';
    }
}



// WEBPACK FOOTER //
// ./resources/js/utils/hook.js